module.exports = __webpack_public_path__ + "img/dots_mobile_lightblue.c91113cc.png";